import React                               from 'react';
import { List, SimpleGrid, Spoiler, Text } from '@mantine/core';
import useIsMounted                        from '@hooks/use-is-mounted';
import { CList }                           from '@core/components/common/CList';
import { convertStrToSnakeCase }           from '@utils/data-utils';
import { CIcon }                           from '@core/components/common/CIcon';
import { CImage }                          from '@core/components/common/CImage';
import useStyles                           from './AmenitiesList.styles'


interface Props {
    amenities: string[];
}

/**
 // ICON FILE NAMES SHOULD LOOK LIKE THIS - snake_case_dark.svg
 // iconDark: '/icons/towels-bed-sheets-dark.svg',
 // iconLight: '/icons/towels-bed-sheets-light.svg',

 // EXCEPT THIS ONE :D
 // soundsystem - write its name as soundsystem_dark.svg
 */

export const AmenitiesList: React.FC<Props> = ({ amenities }) => {

    const { classes } = useStyles();
    const isMounted = useIsMounted();

    const _amenities = amenities || []

    // VISIBLE AMENITIES
    const amenitiesItem = _amenities.map((amenity) => {

        return (
            <List.Item p={10} mt={12} className={classes.amenitiesList}
                       key={amenity}
                // WE CAN SHOW ICONS - IF WE HAVE ALL OF THEM AT ONE PLACE.
                // AS IT WILL REQUIRE SOME LOGICAL WORK TO FIND THE ICON
                // BASED ON AMENITY NAME.
                       icon={
                           // <IconStar size={16} color="orange" radius="sm"/>
                           <CIcon
                               dark={
                                   <CImage
                                       src={`/icons/amenities/${convertStrToSnakeCase(amenity)}-dark.svg`}
                                       alt={convertStrToSnakeCase(amenity)}
                                       width={40}
                                       height={40}
                                   />}
                        light={
                            <CImage
                                src={`/icons/amenities/${convertStrToSnakeCase(amenity)}-light.svg`}
                                alt={convertStrToSnakeCase(amenity)}
                                width={40}
                                height={40}
                            />}
                    />
                }
            >
                <Text align="center" size={16}>{amenity}</Text>
            </List.Item>
        )
    })

    // HIDDEN AMENITIES

    return isMounted && (
        <Spoiler className={classes.amenitiesSpoiler} maxHeight={80} showLabel="Show more" hideLabel="Hide">
            <CList
                spacing="sm"
                size="sm"
                center={true}
                children={
                    <SimpleGrid cols={2} spacing="sm" breakpoints={[{ maxWidth: 'sm', cols: 1 }]}>

                        {amenitiesItem}

                    </SimpleGrid>
                }/>
        </Spoiler>
    )

}
